module.exports = __webpack_public_path__ + "img/dj.25ca580e.png";